var HelpContainer = {
	init:function(){
		console.log("HELP CONTAINER INIT");
		
		$(".btn-help").on("click", function(e){
			/*if(e.type == "touchend"){
				$(this).off("click");
			}*/
			console.log("CLICK HELP");
			$(".help-choose-container").addClass("open");
			
		});
		
		$(".help-choose-container .btn-close").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			
			$(".help-choose-container").removeClass("open");
			
		});
		
		$(".help-choose-container .shadow").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			console.log("CLICK SHADOW");
			$(".help-choose-container").removeClass("open");
			
		});
		
	}
}